export default __webpack_public_path__ + "static/media/default.fbb63e70.png";